import { render, staticRenderFns } from "./Orders_New.vue?vue&type=template&id=3c2f830d&scoped=true"
import script from "./Orders_New.vue?vue&type=script&lang=js"
export * from "./Orders_New.vue?vue&type=script&lang=js"
import style0 from "./Orders_New.vue?vue&type=style&index=0&id=3c2f830d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2f830d",
  null
  
)

export default component.exports